import React, { Component } from 'react';
import { Clients, Partners } from "components";
import styled from "react-emotion";

const StyledRelationships = styled.div`
    
`;

class Relationships extends Component {
    state = {}
    render() {
        const { relationships } = this.props;

        const partners = relationships.edges.filter(relationship => relationship.node.data.relationship_type.document[0].data.relationship_category.text === 'Partner');
        const clients = relationships.edges.filter(relationship => relationship.node.data.relationship_type.document[0].data.relationship_category.text === 'Client');

        return (
            <StyledRelationships id='partners-clients'>
                <Partners partners={partners} />
                <Clients clients={clients} />
            </StyledRelationships>
        );
    }
}

export default Relationships;